import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPPaymentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Voucher/VoucherBrowser")
	}

	render() {
		return (
			<Activity 
				menu="AP05"
				name="FinanceAPPayment"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPPayment"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPPaymentActivity)
